import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { ProductCsvDownloadComponent } from '../../../../widget-library/widgets/product-csv-download/product-csv-download.component';
@Component({
	selector: 'app-product-csv-downnload-r6',
	templateUrl: '../../../../widget-library/widgets/product-csv-download/product-csv-download.component.html',
	// templateUrl: './product-csv-downnload-r6.component.html',
	styleUrls: ['./product-csv-downnload-r6.component.css']
})
export class ProductCsvDownnloadR6Component extends ProductCsvDownloadComponent implements OnInit, OnDestroy {
	@Input() key: string;
	ngOnInit(): void {
		super.ngOnInit();
	}
}
